export default "__VITE_ASSET__Kv6ohIvx__"